















































































































































import { catApi, catInput, catNav, catVue } from "@/util/logging";

import { ProduktModel } from "@/models/ProduktModel";
import { Route } from "vue-router";
import Vue from "vue";
import router from "@/router";
import store from "@/store";

import AuthModule from "@/store/modules/auth";
import { getModule } from "vuex-module-decorators";

const PRODUCT_INPUT_IDLE_FOCUS_DELAY_MS = 60_000;
const SCANNER_MAX_KEY_INTERVAL_MS = 100;
const SCANNER_MIN_KEY_COUNT = 6;
const SCANNER_COMPLETION_DELAY_MS = 250;

export default Vue.extend({
   name: "Regalkontrolle",
   components: {
      BarcodeButton: () =>
         import(
            /* webpackChunkName: "BarcodeButton" */ "@/components/util/BarcodeButton.vue"
         ),
      BuchAnzeige: () =>
         import(
            /* webpackChunkName: "BuchAnzeige" */ "@/components/regalkontrolle/BuchAnzeige.vue"
         ),
      PresseAnzeige: () =>
         import(
            /* webpackChunkName: "PresseAnzeige" */ "@/components/regalkontrolle/PresseAnzeige.vue"
         ),
      ConvenienceAnzeige: () =>
         import(
            /* webpackChunkName: "ConvenienceAnzeige" */ "@/components/regalkontrolle/ConvenienceAnzeige.vue"
         ),
   },
   mounted() {
      window.addEventListener("focus", this.handleWindowFocus);
      window.addEventListener("blur", this.handleWindowBlur);
      window.addEventListener("pageshow", this.handleWindowFocus);
      document.addEventListener("visibilitychange", this.handleVisibilityChange);
      document.addEventListener("focusin", this.handleDocumentFocusIn);
      document.addEventListener("focusout", this.handleDocumentFocusOut);
      this.handleWindowFocus();

      catVue.info(JSON.stringify(this.$route.params));
      this.$nextTick(() => {
         catApi.info("Searching initial produkt ... ?");
         this.search();
      });
   },
   beforeDestroy() {
      window.removeEventListener("focus", this.handleWindowFocus);
      window.removeEventListener("blur", this.handleWindowBlur);
      window.removeEventListener("pageshow", this.handleWindowFocus);
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
      document.removeEventListener("focusin", this.handleDocumentFocusIn);
      document.removeEventListener("focusout", this.handleDocumentFocusOut);
      this.clearFocusTimers();
      if (this.focusChangeTimeout !== undefined) {
         window.clearTimeout(this.focusChangeTimeout);
      }
      if (this.returnFocusTimeout !== undefined) {
         window.clearTimeout(this.returnFocusTimeout);
      }
   },
   data: () => ({
      valid: false,
      base: process.env.VUE_APP_API_ENDPOINT,
      produkt: "",
      // Validation Rules
      produktRules: [
         // eslint-disable-next-line @typescript-eslint/no-explicit-any
         (v: any) => !!v || "Irgendein Produktschlüssel muss sein",
         //          v => v.length <= 10 || 'Name must be less than 10 characters',
      ],
      produktListe: [] as ProduktModel[],
      selectedProdukt: {} as ProduktModel,
      selectionIndex: -1,
      idleFocusTimeout: undefined as number | undefined,
      focusChangeTimeout: undefined as number | undefined,
      returnFocusTimeout: undefined as number | undefined,
      scanCompletionTimeout: undefined as number | undefined,
      lastProductKeyAt: 0,
      rapidProductKeyCount: 0,
      //
      auth: getModule(AuthModule, store),
   }),
   computed: {
      //
      detailComponent(): string {
         catVue.info("detailComponent is called ... " + this.produkt);

         let ret = "";
         if (this.selectedProdukt.kategorie == "Buch") ret = "BuchAnzeige";
         if (this.selectedProdukt.kategorie == "Presse")
            ret = "PresseAnzeige";
         if (this.selectedProdukt.kategorie == "Convenience")
            ret = "ConvenienceAnzeige";

         catVue.info("Returning ... " + ret);
         return ret;
      },
      subtitleLine(): string {
         const parts: string[] = [];

         const pushIfValid = (
            value: string | null | undefined,
            invalidValues: string[] = [],
         ) => {
            const trimmed = (value ?? "").trim();
            if (trimmed.length === 0) return;
            if (
               invalidValues.some(
                  (v) => trimmed.toLowerCase() === v.toLowerCase(),
               )
            )
               return;
            parts.push(trimmed);
         };

         pushIfValid(this.selectedProdukt.untertitel, ["-"]);
         pushIfValid(this.selectedProdukt.zusatztext, ["-"]);

         const vonTrimmed = (this.selectedProdukt.von ?? "").trim();
         const isUnknown = vonTrimmed
            .toLowerCase()
            .startsWith("unbekannter hersteller");
         if (!isUnknown) pushIfValid(vonTrimmed, ["-"]);

         return parts.join(" / ") || "—";
      },
      currentProperties() {
         return { produkt: this.selectedProdukt };
      },
      //
   },
   props: {
      /* intentionally empty */
   },
   methods: {
      //
      getProductInput(): HTMLInputElement | null {
         const field = this.$refs.input as unknown as {
            $refs?: { input?: HTMLInputElement };
         };
         return field?.$refs?.input ?? null;
      },

      isOtherEditableFieldFocused(): boolean {
         const activeElement = document.activeElement;
         const productInput = this.getProductInput();

         return (
            activeElement instanceof HTMLElement &&
            activeElement !== productInput &&
            (activeElement.matches("input, textarea, select") ||
               activeElement.isContentEditable)
         );
      },

      clearFocusTimers(): void {
         if (this.idleFocusTimeout !== undefined) {
            window.clearTimeout(this.idleFocusTimeout);
            this.idleFocusTimeout = undefined;
         }
         if (this.scanCompletionTimeout !== undefined) {
            window.clearTimeout(this.scanCompletionTimeout);
            this.scanCompletionTimeout = undefined;
         }
      },

      resetScanDetection(): void {
         this.lastProductKeyAt = 0;
         this.rapidProductKeyCount = 0;
      },

      focusProductInput(): void {
         const input = this.getProductInput();
         if (!input || document.hidden || this.isOtherEditableFieldFocused()) {
            return;
         }

         input.focus();
         input.select();
      },

      scheduleIdleFocus(): void {
         if (this.idleFocusTimeout !== undefined) {
            window.clearTimeout(this.idleFocusTimeout);
         }
         if (document.hidden || this.isOtherEditableFieldFocused()) {
            this.idleFocusTimeout = undefined;
            return;
         }

         this.idleFocusTimeout = window.setTimeout(() => {
            this.idleFocusTimeout = undefined;
            this.focusProductInput();
            this.scheduleIdleFocus();
         }, PRODUCT_INPUT_IDLE_FOCUS_DELAY_MS);
      },

      onProductKeyDown(event: KeyboardEvent): void {
         if (event.key === "Enter") {
            this.clearFocusTimers();
            this.resetScanDetection();
            this.focusProductInput();
            this.scheduleIdleFocus();
            return;
         }

         if (event.key.length !== 1) return;

         const now = Date.now();
         this.rapidProductKeyCount =
            now - this.lastProductKeyAt <= SCANNER_MAX_KEY_INTERVAL_MS
               ? this.rapidProductKeyCount + 1
               : 1;
         this.lastProductKeyAt = now;
         this.scheduleIdleFocus();

         if (this.rapidProductKeyCount < SCANNER_MIN_KEY_COUNT) return;

         if (this.scanCompletionTimeout !== undefined) {
            window.clearTimeout(this.scanCompletionTimeout);
         }
         this.scanCompletionTimeout = window.setTimeout(() => {
            this.scanCompletionTimeout = undefined;
            this.focusProductInput();
            this.resetScanDetection();
         }, SCANNER_COMPLETION_DELAY_MS);
      },

      handleWindowFocus(): void {
         if (this.returnFocusTimeout !== undefined) {
            window.clearTimeout(this.returnFocusTimeout);
         }
         this.returnFocusTimeout = window.setTimeout(() => {
            this.returnFocusTimeout = undefined;
            this.focusProductInput();
            this.scheduleIdleFocus();
         }, 0);
      },

      handleWindowBlur(): void {
         this.clearFocusTimers();
         this.resetScanDetection();
      },

      handleVisibilityChange(): void {
         if (!document.hidden) this.handleWindowFocus();
      },

      handleDocumentFocusIn(): void {
         if (this.isOtherEditableFieldFocused()) {
            this.clearFocusTimers();
         } else {
            this.scheduleIdleFocus();
         }
      },

      handleDocumentFocusOut(): void {
         if (this.focusChangeTimeout !== undefined) {
            window.clearTimeout(this.focusChangeTimeout);
         }
         this.focusChangeTimeout = window.setTimeout(() => {
            this.focusChangeTimeout = undefined;
            if (this.isOtherEditableFieldFocused()) {
               this.clearFocusTimers();
            } else {
               this.scheduleIdleFocus();
            }
         }, 0);
      },

      submit(): void {
         // eslint-disable-next-line @typescript-eslint/no-explicit-any
         if (!(this.$refs.form as any).validate()) return;

         let update = !(
            "produkt" in this.$route.params &&
            this.produkt == this.$route.params.produkt
         );

         if (update) {
            catVue.info(`Pushing new Route with ${this.produkt}`);
            this.$nextTick(() => {
               router.push({
                  name: "Regalkontrolle",
                  params: { produkt: this.produkt },
               });
            });
         } else {
            catVue.info(`No new Route (${this.produkt})`);
            this.focusProductInput();
         }
      },

      async search() {
         //
         let produkt = "";
         this.selectedProdukt = {} as ProduktModel;
         this.selectionIndex = -1;
         this.produktListe = [];

         if ("produkt" in this.$route.params) {
            produkt = this.$route.params.produkt.trim();
         }

         if (produkt !== this.produkt) {
            catVue.info(`Update this.produkt = (${produkt})`);
            this.produkt = produkt;
         }

         catInput.info("Input: " + produkt);
         if (produkt == "") {
            return;
         }

         try {
            this.$store.commit("changeAppLoadingState", true, {
               root: true,
            });
            const response = await ProduktModel.find(this.produkt);
            this.$store.commit("changeAppLoadingState", false, {
               root: true,
            });
            catApi.debug("Output: " + JSON.stringify(response));

            this.produktListe = response;
            if (0 == response.length) {
               store.commit(
                  "setLastError",
                  `Nichts gefunden zu "${this.produkt}"`,
               );
            } else {
               this.selectedProdukt = this.produktListe[0];
            }
         } catch (e) {
            catApi.error("RegalKontrolle: " + e, null);
            //               store.commit("setLastError", e);
         }

         this.focusProductInput();
      },
   },
   watch: {
      selectionIndex(to: number, from: number): void {
         catNav.info(
            `${this.$options.name}:: selectionIndex '${from}' > '${to}' ` +
               "", //JSON.stringify(to)
         );

         if (
            this.selectionIndex >= 0 &&
            this.selectionIndex < this.produktListe.length
         ) {
            this.selectedProdukt = this.produktListe[this.selectionIndex];
            // console.log(this.selectedProdukt, this.selectedProdukt.fmtPreis());
         }
      },

      $route(to: Route, from: Route): void {
         catNav.info(
            `${this.$options.name}:: Route '${from.fullPath}' > '${to.fullPath}' ` +
               "", //JSON.stringify(to)
         );

         if ("produkt" in to.params) {
            catVue.info("searching ...");
            this.search();
         }
      },
   },
});
